{% block swag_language_pack_flag %}
<div class="swag-language-pack-flag">
    <img :src="assetFilter(`swaglanguagepack/static/flags/${countryCode}.svg`)">
</div>
{% endblock %}
